import React from 'react';
import { Skeleton } from 'antd';
import { SkeletonProps } from 'antd/lib/skeleton';

export type { SkeletonProps };

const ProSkeleton: React.FC<SkeletonProps> = (props) => {
  const { children, ...resProps } = props;

  return <Skeleton {...resProps}>{children}</Skeleton>;
};

export default ProSkeleton;
